<template>
   <div>
        <div>
            <v-form
               ref="create_data"
               v-model="valid_create_data"
            >  

            <div class="container">
               <div class="grid gap-3">
                  <!-- IMMAGINE PROFILO -->
                  <registration-title :title="$t('Immagine profilo')">
                  </registration-title>

                  <input
                     id="files"
                     class="hidden"
                     type="file"
                     multiple
                     @change="onChange()"
                     ref="file"
                     :accept="format_imgs.extension"
                  />
                  <div class="">
                     <div class="grid md:grid-cols-3 gap-4">
                        <div>
                           <div v-if="to_upload || (img_old && !img_url)">
                              <img :src="to_upload ? createUrl(to_upload) : componeSrc(img_old) " class="drop-shadow-md rounded-full min-w-full">
                              <label for="files" class="block text-primary mt-2">{{$t('Seleziona unaltra immagine')}}</label>
                              <div v-if="error_size_img" class="text-red flex flex-col items-center">
                                 <p>{{$t('errore_superato_15Mb')}}</p>
                              </div>
                           </div>
                           <div v-else-if="img_url" class="relative max-w-[280px] mx-auto">
                              <cropper
                                 class="cropper max-w-100"
                                 :src="img_url"
                                 :stencil-props="{
                                          aspectRatio: 1/1,
                                          previewClass: 'preview'
                                       }"
                                       stencil-component="circle-stencil"
                                 @change="change"
                              />
                              <div>
                                 <label for="files" class="block text-primary">{{$t('Seleziona unaltra immagine')}}</label>
                                 <v-btn dark color="green" @click="setNewImgProfile">{{$t('Conferma')}}</v-btn>
                              </div>
   
                              <v-text-field
                                 class="input_transparent input_transparent__absolute input_transparent__absolute__25"
                                 :rules="disable_rules ? [] : [validation_rules.required]"
                                 v-model="to_upload"
                              ></v-text-field>
                           </div>
                           <div v-else class="relative">
                              <upload-files
                                 id="996"
                                 :format="format_imgs"
                                 :p_filelist="img"
                                 :reset="true"
                                 @fileListChange="imgsChange"
                              >
                                 <span>
                                    {{$t('Rilascia limmagine qui o')}} <br>
                                    <b>{{$t('seleziona il file')}}</b> <br>
                                    <small class="block text-[#808080]">{{$t('Massimo 15Mb')}}</small>
                                 </span>
                                 <template v-slot:error>
                                    <div v-if="error_size_img" class="text-red flex flex-col items-center">
                                       <p class="mb-0">{{$t('errore_superato_15Mb')}}</p>
                                    </div>
                                 </template>
                              </upload-files>    
                              <v-text-field
                                 class="input_transparent input_transparent__absolute "
                                 style="bottom: -20px"
                                 :rules="disable_rules ? [] : [validation_rules.required]"
                                 v-model="to_upload"
                              ></v-text-field>     
                                     
                           </div>
                        </div>
                        <div class="md:col-span-2">
                           <p>{{$t('info_img_profile')}}</p>
                        </div>
                        
                     </div>
                  </div>

                  <!-- DATI PERSONALI -->
                  <registration-title :title="$t('Dati Personali')">
                  </registration-title>

                  <div class="">
                     <div class="grid md:grid-cols-2 gap-2">
                        
                        <!-- Genere -->
                        <div>
                           <p class="label-radio-group mb-0">{{$t('Genere')}}:</p>
                           <div class="flex flex-col md:flex-row relative gap-1 md:gap-2">
                              <div v-for="item_gender in items_gender" :key="item_gender">
                                 <flip-check
                                    outlined
   
                                    :check="user.genere == item_gender"
                                    :label="$t(item_gender)"
                                    @changeCheck="user.genere = item_gender"
                                    scale=".7"
                                 >
                                 </flip-check>
                              </div>
                              <v-text-field
                                 :rules="disable_rules ? [] : [validation_rules.required]"
                                 class="input_transparent input_transparent__absolute pt-3"
                                 v-model="user.genere"
                              ></v-text-field>
                           </div>
                        </div>
   
                        <!-- Altro genere -->
                        <div>
                           <v-text-field
                              v-if="user.genere == 'altro'"
                              :rules="disable_rules ? [] : [validation_rules.required]"
                              :label="$t('Altro genere')"
                              outlined
                              dense
                              hide-details="auto"
                              :disabled="user.genere != 'altro'"
                              v-model="user.genereAltro"
                           ></v-text-field>
                        </div>
   
                        <!-- Nome -->
                        <div>
                           <v-text-field
                              :rules="disable_rules ? [] : [validation_rules.required, validation_rules.counter_30]"
                              :label="$t('Nome')  + '*'"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="user.nome"
                           ></v-text-field>
                        </div>
   
                        <!-- Cognome -->
                        <div>
                           <v-text-field
                              :rules="disable_rules ? [] : [validation_rules.required, validation_rules.counter_30]"
                              :label="$t('Cognome') + '*'"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="user.cognome"
                           ></v-text-field>
                        </div>
   
                        <!-- Luogo nascita -->
                        <div>
                           <v-text-field
                              :rules="disable_rules ? [] : [validation_rules.required, validation_rules.counter_30]"
                              :label="$t('Luogo nascita') + '*'"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="user.luogonascita"
                           ></v-text-field>
                        </div>
   
                        <!-- Data nascita -->
                        <div v-if="user">
                           <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              max-width="290"
                           >
                              <template v-slot:activator="{ on, attrs }">
                                 <v-text-field
                                    :label="$t('Data nascita') + '*'"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    clearable
                                    
                                    :value="computedDateFormattedMomentjs"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    @click:clear="user.dataNascita = null"
                                 ></v-text-field>
                              </template>
                              <v-date-picker
                                 no-title
                                 :max="adult_age_date"
                                 :show-current="adult_age_date"
                                 v-model="user.dataNascita"
                                 @change="menu1 = false"
                                 :locale="$i18n.locale"
                              ></v-date-picker>
                           </v-menu>
                        </div>
   
                        <!-- Email -->
                        <div>
                           <v-text-field
                              :rules="disable_rules ? [] : [validation_rules.required, validation_rules.email]"
                              :label="$t('E-mail')"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="user.email"
                           ></v-text-field>
                        </div>
   
                        <!-- CF -->
                        <div>
                           <v-text-field
                              :rules="disable_rules ? [] : [validation_rules.required, validation_rules.codice_fiscale, validation_rules.found(cf_found)]"
                              :label="$t('Codice fiscale')"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="user.cf"
                           ></v-text-field>
                        </div>
   
                        <!-- Telefono -->
                        <div class="relative">
                           <v-text-field
                              class="v-text-field--absolute-no-click-hidden"
                              :rules="disable_rules ? [validation_rules.phone_match(user.cellulare ? user.cellulare : '', user.altrotelefono ? user.altrotelefono : '')] : [validation_rules.required, validation_rules.phone_match(user.cellulare ? user.cellulare : '', user.altrotelefono ? user.altrotelefono : ''), validation_rules.found(phone_found)]"
                              hide-details="auto"
                              v-model="user.cellulare"
                           ></v-text-field>
                           <small class="vue-tel-input--label">{{$t('Telefono')}}</small>
                           <vue-tel-input
                              v-model="user.cellulare"
                              v-bind="bindProps"
                              @input="validationPhone1"
                              @change="validationPhone1"
   
                              :inputOptions="{ placeholder : $t('Numero di telefono')}"
                              class="vue-tel-input"
                              :class="{
                                 'vue-tel-input__valid': validation_phone.valid == true,
                                 'vue-tel-input__invalid': validation_phone.valid == false,
                              }"
                           ></vue-tel-input>
                        </div>
   
                        <!-- altro telefono -->
                        <div class="relative">
                           <v-text-field
                              class="v-text-field--absolute-no-click-hidden"
                              :rules="disable_rules ? [validation_rules.phone_match(user.cellulare ? user.cellulare : '', user.altrotelefono ? user.altrotelefono : '')] : [validation_rules.phone_match(user.cellulare ? user.cellulare : '', user.altrotelefono ? user.altrotelefono : ''), validation_rules.found(phone2_found)]"
                              hide-details="auto"
                              v-model="user.altrotelefono"
                           ></v-text-field>
                           <small class="vue-tel-input--label">{{$t('Altro telefono')}}</small>
                           <vue-tel-input
                              v-model="user.altrotelefono"
                              v-bind="bindProps"
                              @input="validationPhone2"
                              @change="validationPhone2"
   
                              :inputOptions="{ placeholder : $t('Secondo telefono')}"
                              class="vue-tel-input"
                              :class="{
                                 'vue-tel-input__valid': validation_phone_2.valid == true,
                                 'vue-tel-input__invalid': validation_phone_2.valid == false,
                              }"
                           ></vue-tel-input>
                        </div>
   
                        <!-- Auto -->
                        <div>
                           <p class="label-radio-group mb-0">{{$t('Auto munito')}}: </p>
                           <div class="flex gap-2">
                              <div>
                                 <flip-check
                                    outlined
                                    :radio="true"
                                    :check="user.automunita == true"
                                    :label="$t('Si')"
                                    @changeCheck="user.automunita = true"
                                    scale=".7"
                                 >
                                 </flip-check>
                              </div>
                              <div>
                                 <flip-check
                                    outlined
                                    :radio="true"
                                    icon_true="close-thick"
                                    color_true="red"
                                    :check="user.automunita == false || user.automunita == null"
                                    :label="$t('No')"
                                    @changeCheck="user.automunita = false"
                                    scale=".7"
                                 >
                                 </flip-check>
                              </div>
                           </div>
                        </div>
   
                        <!-- Moto -->
                        <div>
                           <p class="label-radio-group mb-0">{{$t('Moto munito')}}: </p>
                           <div class="flex gap-2">
                              <div>
                                 <flip-check
                                    outlined
                                    :radio="true"
                                    :check="user.motomunita == true"
                                    :label="$t('Si')"
                                    @changeCheck="user.motomunita = true"
                                    scale=".7"
                                 >
                                 </flip-check>
                              </div>
                              <div>
                                 <flip-check
                                    outlined
                                    :radio="true"
                                    icon_true="close-thick"
                                    color_true="red"
                                    :check="user.motomunita == false || user.motomunita == null"
                                    :label="$t('No')"
                                    @changeCheck="user.motomunita = false"
                                    scale=".7"
                                 >
                                 </flip-check>
                              </div>
                           </div>
                        </div>

                        <!-- Moto -->
                        <div>
                           <p class="label-radio-group mb-0">{{$t('Haccp')}}: </p>
                           <div class="flex gap-2">
                              <div>
                                 <flip-check
                                    outlined
                                    :radio="true"
                                    :check="user.haccp == 1"
                                    :label="$t('Si')"
                                    @changeCheck="user.haccp = 1"
                                    scale=".7"
                                 >
                                 </flip-check>
                              </div>
                              <div>
                                 <flip-check
                                    outlined
                                    :radio="true"
                                    icon_true="close-thick"
                                    color_true="red"
                                    :check="user.haccp == 0 || user.haccp == null"
                                    :label="$t('No')"
                                    @changeCheck="user.haccp = 0"
                                    scale=".7"
                                 >
                                 </flip-check>
                              </div>
                           </div>
                        </div>
   
                        <!-- Instagram -->
                        <!-- <div>
                           <v-text-field
                              :label="$t('Instagram')"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="user.instagram"
                           ></v-text-field>
                        </div> -->

                        <div class="md:col-span-2">
                           <p class="label-radio-group mb-0">
                              <span class="hidden lg:inline">
                                 {{$t('Instagram')}}
                              </span>
                           </p>
                           <div class="input-group-social">
                              <div class="input-group-social--name">
                                 https://www.instagram.com/
                              </div>
                              <v-text-field
                                 outlined
                                 dense
                                 hide-details="auto"
                                 v-model="user.instagram"
                              ></v-text-field>
                              <v-btn              
                                 color="#2f2f2f"
                                 elevation="1"
                                 outlined
                                 icon
                                 tile
                                 style="height: 33px; width: 33px; margin-bottom: 1px; border-radius: 3px;"
                                 :disabled="!user.instagram"
                                 :href="user.instagram ? 'https://www.instagram.com/' + user.instagram : ''"
                                 target="_blank"
                              >  
                                    <v-icon>mdi-open-in-new</v-icon>
                              </v-btn>
                           </div>
                        </div>

                        <div class="md:col-span-2">
                           <p class="label-radio-group mb-0">
                              <span class="hidden lg:inline">
                                 {{$t('TikTok')}}
                              </span>
                           </p>
                           <div class="input-group-social">
                              <div class="input-group-social--name">
                                 https://www.tiktok.com/@
                              </div>
                              <v-text-field
                                 outlined
                                 dense
                                 hide-details="auto"
                                 v-model="user.tiktok"
                              ></v-text-field>
                              <v-btn              
                                 color="#2f2f2f"
                                 elevation="1"
                                 outlined
                                 icon
                                 tile
                                 style="height: 33px; width: 33px; margin-bottom: 1px; border-radius: 3px;"
                                 :disabled="!user.tiktok"
                                 :href="user.tiktok ? 'https://www.tiktok.com/@' + user.tiktok : ''"
                                 target="_blank"
                              >  
                                    <v-icon>mdi-open-in-new</v-icon>
                              </v-btn>
                           </div>
                        </div>

                        <div class="md:col-span-2">
                           <p class="label-radio-group mb-0">
                              <span class="hidden lg:inline">
                                 {{$t('Facebook')}}
                              </span>
                           </p>
                           <div class="input-group-social">
                              <div class="input-group-social--name">
                                 https://www.facebook.com/
                              </div>
                              <v-text-field
                                 outlined
                                 dense
                                 hide-details="auto"
                                 v-model="user.facebook"
                              ></v-text-field>
                              <v-btn              
                                 color="#2f2f2f"
                                 elevation="1"
                                 outlined
                                 icon
                                 tile
                                 style="height: 33px; width: 33px; margin-bottom: 1px; border-radius: 3px;"
                                 :disabled="!user.facebook"
                                 :href="user.facebook ? 'https://www.facebook.com/' + user.facebook : ''"
                                 target="_blank"
                              >  
                                    <v-icon>mdi-open-in-new</v-icon>
                              </v-btn>
                           </div>
                        </div>

                        <div class="md:col-span-2">
                           <p class="label-radio-group mb-0">
                              <span class="hidden lg:inline">
                                 {{$t('Linkedin')}}
                              </span>
                           </p>
                           <div class="input-group-social">
                              <div class="input-group-social--name">
                                 https://www.linkedin.com/in/
                              </div>
                              <v-text-field
                                 outlined
                                 dense
                                 hide-details="auto"
                                 v-model="user.linkedin"
                              ></v-text-field>
                              <v-btn              
                                 color="#2f2f2f"
                                 elevation="1"
                                 outlined
                                 icon
                                 tile
                                 style="height: 33px; width: 33px; margin-bottom: 1px; border-radius: 3px;"
                                 :disabled="!user.linkedin"
                                 :href="user.linkedin ? 'https://www.linkedin.com/in/' + user.linkedin : ''"
                                 target="_blank"
                              >  
                                    <v-icon>mdi-open-in-new</v-icon>
                              </v-btn>
                           </div>
                        </div>
   
                        <!-- note -->
                        <div class="md:col-span-2">
                           <v-textarea
                              :label="$t('Note')"
                              row-height="250"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="user.notepubblico"
                           ></v-textarea>
                        </div>
   
                     </div>
                  </div>

                  <!-- DOCUMENTI -->
                  <!-- <registration-title :title="$t('Documento')">
                  </registration-title>

                  <div class="">
                     <div class="grid md:grid-cols-2 gap-2">
                        
                        <div class="flex flex-col gap-[.5rem]">
   
                           <span>{{$t('Tipo Documento')}}</span>
                           <v-autocomplete
                              :rules="(disable_rules || ((user_files && user_files['casting/ci'].length) && !doc.type && !doc.file) || !doc.file) ? [] : [validation_rules.required]"
                              v-model="doc.type"
                              :items="items_type_docs"
                              item-text="text"
                              item-value="value"
                              hide-details="auto"
                              outlined
                              dense
                           ></v-autocomplete>
                        </div>
                        <div v-if="['cf', 'ci', 'passaporto', 'patente', 'permesso_soggiorno'].includes(doc.type)" class="md:pt-3">
                           <v-text-field
                              :rules="(disable_rules || !doc.file) ? [] : [validation_rules.required]"
                              :label="$t('Nome documento')"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="doc.name"
                           ></v-text-field>
                        </div>
                        <div v-if="['cf', 'ci', 'passaporto', 'patente', 'permesso_soggiorno'].includes(doc.type)">
                           <v-text-field
                              :label="$t('Numero documento')"
                              :rules="(disable_rules || !doc.file) ? [] : [validation_rules.required]"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="doc.number"
                           ></v-text-field>
                        </div>
                        <div v-if="['ci', 'passaporto', 'patente', 'cf'].includes(doc.type)">
                           <v-text-field
                              :label="$t('Residenza')"
                              :rules="(disable_rules || !doc.file) ? [] : [validation_rules.required]"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="doc.residenza"
                           ></v-text-field>
                        </div>
                        <div v-if="['passaporto'].includes(doc.type)">
                           <v-text-field
                              :label="$t('Cittadinanza UE')"
                              :rules="(disable_rules || !doc.file) ? [] : [validation_rules.required]"
                              outlined
                              dense
                              hide-details="auto"
                              v-model="doc.cittadinanza"
                           ></v-text-field>
                        </div>
                        
                        <div v-if="['cf', 'ci', 'passaporto', 'patente', 'permesso_soggiorno'].includes(doc.type)">
                           <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              max-width="290"
                           >
                              <template v-slot:activator="{ on, attrs }">
                                 <v-text-field
                                    :label="$t('Data Scadenza')"
                                    :rules="(disable_rules || !doc.file) ? [] : [validation_rules.required]"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    clearable
                                    
                                    :value="computedDateFormattedMomentjsScadenza"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    @click:clear="doc.data_scadenza = null"
                                 ></v-text-field>
                              </template>
                              <v-date-picker
                                 no-title
                                 :min="tomorrow('')"
                                 v-model="doc.data_scadenza"
                                 @change="menu2 = false"
                                 :locale="$i18n.locale"
                              ></v-date-picker>
                           </v-menu>
                        </div>
   
                        <div class="md:col-span-2">
                           <upload-files
                              id="778"
                              :format="format_docs"
                              :p_filelist="doc.file"
                              @fileListChange="docsChange"
                              :reset="true"
                           >
                              <span>
                                 {{$t('Rilascia il documento qui o')}} <br>
                                 <b>{{$t('seleziona il documento')}}</b> <br>
                                 <small class="text-[#808080]">({{format_docs.extension}})</small>
                                 <small class="block text-[#808080]">{{$t('Massimo 15Mb')}}</small>
                              </span>
                              <div v-if="doc.file">
                                 <hr class="my-1">
                                 <small class="text-[#757373]">{{doc.file.name}}</small>
                                 <hr class="my-1" v-if="error_size">
                              </div>
                              <template v-slot:error>
                              <div v-if="error_size" class="text-red flex flex-col items-center">
                                 <p>{{$t('errore_superato_15Mb')}}</p>
                                 <a class="text-red" @click="doc.file = null">{{$t('Reset')}}</a>
                              </div>
                           </template>
                           </upload-files>
                           <div class="relative mt-2">
                              <v-text-field
                                 class="input_transparent input_transparent__absolute"
                                 v-model="doc.file"
                              ></v-text-field>
                           </div>
                        </div>
                     </div>
                  </div> -->
               </div>
            </div>

               <div class="flex justify-between items-end mt-5 pt-1 border-t border-[#e5e7eb]">
                  <!-- <a color="#808080" @click="logout">Logout</a> -->
                  <!-- <v-btn color="grey" dark :loading="btn_loading" @click="$emit('nextStep',1)">Indietro</v-btn> -->
                  <span></span>
                  <v-btn
                     color="green"
                     dark
                     :loading="btn_loading"
                     @click="nextStep()"
                     :disabled="error_size || error_size_img"
                  >{{$t('Avanti')}}</v-btn>
               </div>
            </v-form>
        </div>
   </div>
</template>

<script>
import moment from "moment";

import UploadFiles from "@/components/UploadFiles.vue";
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

// import heic2any from "heic2any";

export default {
   components: {
		Cropper,
      UploadFiles
	},
    data() {
      return {
         img: '',
         img_url: '',
         format_imgs: {
            extension: ".jpeg,.jpg,.png,.webp",
            format: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']
         },

         to_upload: null,

         img_cropped: null,
         img_old: null,

         // doc: {
         //    type: "",
         //    name: "",
         //    number: "",
         //    data_scadenza: "",
         //    residenza: "",
         //    cittadinanza: "",
         //    file: null
         // },
         // format_docs: {
         //    extension: ".pdf,.odt,.odp,.doc,.docx,.pps,.ppsx,.ppt,.pptx,.txt,.png,.jpg,.jpeg,.heic,.heif,webp",
         //    format: [
         //       'application/pdf',
         //       'application/vnd.oasis.opendocument.text',
         //       'application/vnd.oasis.opendocument.presentation',
         //       'application/msword',
         //       'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
         //       'application/vnd.ms-powerpoint',
         //       'application/vnd.openxmlformats-officedocument.presentationml.presentation',
         //       'text/plain',
         //       'image/png',
         //       'image/jpeg',
         //       'image/heic',
         //       'image/heif',
         //       'image/webp'
         //    ],
         // },

         btn_loading: false,
         disable_rules: true,
         valid_create_data: true,

         validation_phone: {},
         validation_phone_2: {},

         phone_found: false,
         phone2_found: false,
         cf_found: false,

         dataNascita: null,
         menu1: false,
         menu2: false,

         items_gender: ['uomo', 'donna', 'altro'],

         error_size: false,

         error_size_img: false,
         size_total_img: 0,

         to_upload_base64: null,
      };
   },
   computed: {
      items_type_docs(){
         return [
            {  text: this.$t('Carta di identità'), value: "ci" },
            {  text: this.$t('Codice fiscale'), value: "cf" },
            {  text: this.$t('Patente'), value: "patente"  },
            {  text: this.$t('Passaporto'), value: "passaporto"  },
            {  text: this.$t('Permesso soggiorno'), value: "permesso_soggiorno"  },
            {  text: this.$t('altro'), value: "ci" }
         ]
      },
      user() {
         let _user = this.$store.getters['user/user']
         if(_user && _user.dataNascita){
            if(moment(_user.dataNascita, 'DD/MM/YYYY')._isValid){
               _user.dataNascita = moment(_user.dataNascita, 'DD/MM/YYYY').format("YYYY-MM-DD")
            }
         }

         if(_user.immagineProfiloPreferito){
            this.setOldImg(_user.immagineProfiloPreferito)
         }

         console.log("user",_user);
         return _user
      },
      user_files() {
         let _user_files = this.$store.getters['user/user_files']

         return _user_files
      },
      computedDateFormattedMomentjs () {
         if(this.user && this.user.dataNascita){
            return this.user.dataNascita ? moment(this.user.dataNascita).format('DD/MM/YYYY') : null
         }
         return null
      },
      computedDateFormattedMomentjsScadenza () {
         if(this.doc && this.doc.data_scadenza){
            return this.doc.data_scadenza ? moment(this.doc.data_scadenza).format('DD/MM/YYYY') : null
         }
         return null
      },
   },
   watch: {
      "user.genere"(){
         if(this.user){
            if(this.user.genere != 'altro')
               this.user.genereAltro = ''
         }
      },
      "user.cellulare"(){
         this.phone_found = false
      },
      "user.altrotelefono"(){
         this.phone2_found = false
      },
      "user.cf"(){
         this.cf_found = false
      },
      "doc.type"(){
         this.doc.number = ""
         this.doc.data_scadenza = ""
         this.doc.residenza = ""
         this.doc.cittadinanza = ""
      },
      // controllo dimensioni fili
      "doc.file"(new_file){

            this.error_size = false
            if( new_file.size > 15000000){
               this.error_size = true
            }

      },
      "img"(){
         console.log("img",this.img);
      }

      
   },
   methods: {
      setOldImg(img){
         this.img_old = img
      },
      errorImg(){
         console.log("error");
         this.img_old = ''
      },
      onChange() {

         this.to_upload = null
         this.to_upload_base64 = null
         this.img = ''
         this.img_url = ''
         console.log("1");
         console.log("this.$refs.file.files",this.$refs.file.files);

         if(this.format_imgs.format.includes(this.$refs.file.files[0].type)){

            // controllo dimensioni
            console.log("SIZW",this.$refs.file.files[0].size);
            if( this.$refs.file.files[0].size > 15000000){
               this.error_size_img = true
               this.img = ""
               this.img_url = ""
               return
            }else{
               this.error_size_img = false
               this.img = this.$refs.file.files[0]
               this.img_url = this.createUrl(this.$refs.file.files[0])
            }

         }

         this.$refs.file.value = null
         console.log("2",this.$refs.file.files);
      },
      async setNewImgProfile(){

         const url = this.img_cropped;
         this.to_upload_base64 = url
         fetch(url)
         .then(res => res.blob())
         .then(async (blob) => {
            const file = new File([blob], "file.png",{ type: "image/png" })

            this.to_upload = file

            this.img_old = "";
            this.dialog_crop = false
            this.mode_set = false;
            this.img_cropped = null;
         })

         console.log('Fatto')
      },
      imgsChange(new_filelist){
         console.log("new_filelist",   new_filelist);

         if(new_filelist[0].size > 15000000){
            this.error_size_img = true
            this.img = ""
            this.img_url = ""
            return
         }else{
            this.error_size_img = false
            this.img = new_filelist[0]
            this.img_url = this.createUrl(new_filelist[0])
         }

      },
      docsChange(new_filelist){
         this.doc.file = null
         this.doc.file = new_filelist[0]
      },
      change({ coordinates, canvas }) {
			console.log("change",coordinates, canvas)
         this.img_cropped = canvas.toDataURL("image/jpeg", 1.0);
		},
      async nextStep(){
         this.disable_rules =  false
         await this.delay(200)
         let valid = await this.$refs.create_data.validate();
         if(valid){
            
            let response = await this.sendEdit()

            if(response){
   
               this.$emit("nextStep",2)
            }
            this.btn_loading = false            
            
         }
      },
      async sendEdit(){
         this.btn_loading = true
         let body = {
            genere: this.user.genere,
            genereAltro: this.user.genereAltro,
            nome: this.user.nome,
            cognome: this.user.cognome,
            luogonascita: this.user.luogonascita,
            email: this.user.email,
            cf: this.user.cf.toUpperCase(),
            cellulare: this.user.cellulare ? this.user.cellulare.replaceAll(" ","") : "",
            altrotelefono: this.user.altrotelefono ? this.user.altrotelefono.replaceAll(" ","") : "",
            automunita: this.user.automunita,
            motomunita: this.user.motomunita,
            haccp: this.user.haccp,
            instagram: this.user.instagram,
            tiktok: this.user.tiktok,
            facebook: this.user.facebook,
            linkedin: this.user.linkedin,
            notepubblico: this.user.notepubblico,
            immagineProfilo: 1,
            registrazioneCompletata: this.user.registrazioneCompletata < 2 ? 2 : this.user.registrazioneCompletata
         }

         body.dataNascita = this.user.dataNascita ? moment(this.user.dataNascita).format("DD/MM/YYYY") : null

         let to_promis_all = []
         to_promis_all.push(this.$store.dispatch('user/editUser',body))

         if(this.img_url){
            to_promis_all.push(this.uploadOriginalImg())
         }

         let responses = await Promise.all(to_promis_all)
         let response = responses[0]

         if(response.response.error){
            console.log("ERROR:",response.response.code);

            if(Array.isArray(response.response.message) && response.response.message[0] == "EXISTING_BOTH" || response.response.message == "EXISTING_BOTH"){
               this.phone_found = true
               this.phone2_found = true
            }
            if(Array.isArray(response.response.message) && response.response.message[0] == "EXISTING_CELLULARE" || response.response.message == "EXISTING_CELLULARE"){
               this.phone_found = true
            }
            if(Array.isArray(response.response.message) && response.response.message[0] == "EXISTING_ALTROTELEFONO" || response.response.message == "EXISTING_ALTROTELEFONO"){
               this.phone2_found = true
            }

            if(response.response.code == "unique_cf"){
               this.cf_found = true
            }
            return false
         }

         if(this.to_upload && this.to_upload_base64){
            let file2 = this.to_upload.name.split("?")[0]
            let img_cropped = this.to_upload_base64
            let body = {
               "type": "casting/profilocropped",
               "base64": img_cropped,
               "file2": file2
            }
            await this.$store.dispatch('user/uploadImgProfileJson',body)
         }

         return true
         
      },

      async uploadOriginalImg(){
         let formdata = new FormData();
         formdata.append("type", "casting/foto");
         formdata.append("file", this.img, this.img.name);
         await this.$store.dispatch('user/uploadFiles',formdata)
         this.save_loading = false
         this.dialog = false
         this.filelist_imgs = []
         
      },

      validationPhone1(formattedNumber, { number, valid, country }) {
         if(this.user && this.validation_phone){
            this.validation_phone.formattedNumber = formattedNumber;
            this.validation_phone.number = number;
            this.validation_phone.valid = valid;
            this.validation_phone.country = country && country.name;
            if(this.user.cellulare.charAt(0) != '+'){
               this.user.cellulare = number
            }
         }
      },
      validationPhone2(formattedNumber, { number, valid, country }) {
         if(this.user && this.validation_phone_2){
            this.validation_phone_2.formattedNumber = formattedNumber;
            this.validation_phone_2.number = number;
            this.validation_phone_2.valid = valid;
            this.validation_phone_2.country = country && country.name;
            if(this.user.altrotelefono.charAt(0) != '+'){
               this.user.altrotelefono = number
            }
         }
      }
   },
};
</script>

<style lang="scss" scoped>
/*  */
.cropper {
	// height: 600px;
   max-height: 300px;
	width: 100%;
	background: #DDD;
}

// .input-group-social{
//    position: relative;
//    display: flex;
//    gap: 1rem;
//    align-items: end;
//    &--name{
//       position: absolute;
//       left: 0;
//       bottom: 0;
//       height: calc(100% - 5px);
//       border-radius: 5px 0 0 5px;
//       background: #f1f1f1;
//       display: flex;
//       align-items: center;
//       padding: 0 10px;
//       width: 240px;
//       border-right: 1px solid #9e9e9e;
//    }
//    .v-input__slot{
//       padding-left: 250px !important;
//    }

//    @media screen and (max-width: 728px) {
//       &--name{
//          display: none;
//          // font-size: 11px !important;
//          // width: 185px !important;
//       }
//       v-input__slot{
//          padding-left: 10px !important;
//       }
//    }

// }
</style>
